var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wa-contact-item",
      class: {
        "wa-contact-item--active": _vm.isActive,
        "wa-contact-item--unread": _vm.contact.unread,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click", _vm.contact)
        },
      },
    },
    [
      _c("div", { staticClass: "wa-contact-item__avatar" }, [
        _c(
          "div",
          {
            staticClass: "wa-contact-item__avatar-circle",
            style: _vm.avatarStyle,
          },
          [
            _vm.avatarUrl
              ? _c("img", {
                  staticClass: "wa-contact-item__avatar-img",
                  attrs: { src: _vm.avatarUrl, alt: "" },
                  on: { error: _vm.onAvatarError },
                })
              : _c(
                  "span",
                  { staticClass: "wa-contact-item__avatar-initials" },
                  [_vm._v(_vm._s(_vm.initials))]
                ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wa-contact-item__content" }, [
        _c(
          "div",
          { staticClass: "wa-contact-item__row wa-contact-item__row--top" },
          [
            _c("span", { staticClass: "wa-contact-item__name" }, [
              _vm._v(_vm._s(_vm.displayName)),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "wa-contact-item__time",
                class: { "wa-contact-item__time--unread": _vm.contact.unread },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.displayTime) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wa-contact-item__row wa-contact-item__row--bottom" },
          [
            _c("div", { staticClass: "wa-contact-item__last-msg" }, [
              _vm.lastMessageIcon
                ? _c(
                    "span",
                    { staticClass: "wa-contact-item__msg-icon material-icons" },
                    [_vm._v(_vm._s(_vm.lastMessageIcon))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "wa-contact-item__msg-text" }, [
                _vm._v(_vm._s(_vm.lastMessageText)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wa-contact-item__indicators" }, [
              _vm.contact.vipCustomer
                ? _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            content: _vm.$t("whatsappUi.vipCustomerTooltip"),
                          },
                          expression:
                            "{ content: $t('whatsappUi.vipCustomerTooltip') }",
                        },
                      ],
                      staticClass: "wa-contact-item__vip",
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("star"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.contact.unread && _vm.unreadCount > 0
                ? _c("span", { staticClass: "wa-contact-item__unread-badge" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.unreadCount > 99
                            ? _vm.$t("whatsappUi.unreadOverflow")
                            : _vm.unreadCount
                        ) +
                        "\n                "
                    ),
                  ])
                : _vm.contact.unread
                ? _c("span", { staticClass: "wa-contact-item__unread-dot" })
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }